<template>
  <div>
    <a-card :loading="spinning" class="version-detail">
      <a-page-header :title="versionData.title" sub-title="迭代详情" @back="() => $router.go(-1)">
        <template slot="extra">
          <span v-if="versionData.id && versionData.id !== -1" class="version-action">
            <version-status-edit :version-id="versionData.id" :status="versionData.status" @change="onChange" />
            <a-icon
              v-has="{ code: 'project:version:edit', project: projectId }"
              class="version-setting"
              type="setting"
              theme="filled"
              @click="onEdit"
            />
          </span>
        </template>
        <a-descriptions size="small" :column="3">
          <a-descriptions-item label="状态">
            <div v-if="versionStatus[versionData.status]">
              <a-badge
                :status="versionStatus[versionData.status].status"
                :text="versionStatus[versionData.status].label"
              />
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="预计开始时间"> {{ versionData.pre_start_time || '--' }}</a-descriptions-item>
          <a-descriptions-item label="预计结束时间"> {{ versionData.pre_end_time || '--' }}</a-descriptions-item>
          <a-descriptions-item label="开始时间"> {{ versionData.start_time || '--' }}</a-descriptions-item>
          <a-descriptions-item label="结束时间"> {{ versionData.end_time || '--' }}</a-descriptions-item>
          <a-descriptions-item v-if="versionData.creator" label="创建人">{{
            versionData.creator.name
          }}
          </a-descriptions-item>
          <a-descriptions-item label="创建时间"> {{ versionData.created_time }}</a-descriptions-item>
          <a-descriptions-item label="更新时间"> {{ versionData.updated_time }}</a-descriptions-item>
        </a-descriptions>
      </a-page-header>
      <a-tabs v-model="tabsCurrent" default-active-key="1" size="small" @change="handleTabsChange">
        <a-tab-pane key="1" tab="详细信息">
          <div class="ql-container ql-snow">
            <div class="ql-editor">
              <div v-html="versionData.description" />
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="需求列表" force-render>
          <sub-story-list ref="2" :filter-form="filterForm" :version-id="versionId" />
        </a-tab-pane>
        <a-tab-pane key="3" tab="计划和进度" force-render>
          <story-plan-list ref="3" :filter-form="filterForm" @setTotal="setTotal" />
        </a-tab-pane>
        <a-tab-pane key="4" tab="需求规划">
          <story-plan-gantt ref="4" :filter-form="filterForm" @setTotal="setTotal" />
        </a-tab-pane>
        <a-tab-pane key="5" tab="变更历史">
          <version-changelog ref="changelog" :version-id="versionData.id" />
        </a-tab-pane>
      </a-tabs>
      <CommentPanel mode="version" :active-key="activeKey" :source-id="versionData.id" />
    </a-card>
    <version-edit :is-show="editVisible" :version-id="versionId" :version-data="versionData" @close="close" />
  </div>
</template>

<script>
import { versionStatus } from '@/utils/dictionary';
import { versionDetail } from '@/api/project/version';
import StoryPlanList from '@/pages/project/story/components/StoryPlanList';
import StoryPlanGantt from '@/pages/project/story/components/StoryPlanGantt';
import VersionStatusEdit from '@/pages/project/version/components/VersionStatusEdit';
import VersionEdit from '@/pages/project/version/components/VersionEdit';
import CommentPanel from '@/components/comment/CommentPanel';
import SubStoryList from '@/pages/project/story/components/SubStoryList';
import VersionChangelog from '@/pages/project/version/components/VersionChangelog';

export default {
  name: 'Detail',
  components: {
    SubStoryList,
    StoryPlanList,
    StoryPlanGantt,
    VersionStatusEdit,
    VersionEdit,
    CommentPanel,
    VersionChangelog
  },
  data() {
    return {
      versionStatus,
      spinning: true,
      versionData: {},
      editVisible: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      versionId: parseInt(this.$route.query.version_id) || null,
      tabsCurrent: '1',
      total: 0,
      filterForm: {
        project_id: parseInt(this.$route.params.project_id) || null,
        version_id: parseInt(this.$route.query.version_id) || null
      },
      activeKey: []
    };
  },
  created() {
    this.getVersionDetail();
  },
  methods: {
    getVersionDetail() {
      versionDetail({ project_id: this.projectId, version_id: this.version_id }).then(res => {
        this.versionData = res.data.item;
        this.spinning = false;
        this.activeKey = [];
        this.activeKey.push('1');
      });
    },
    setTotal(total) {
      this.total = total;
    },
    handleTabsChange() {
      if (!['1', '5'].includes(this.tabsCurrent)) {
        this.$nextTick(() => {
          this.$refs[this.tabsCurrent].handleChange();
        });
      }
    },
    onEdit() {
      this.editVisible = true;
    },
    onChange() {
      this.getVersionDetail();
    },
    close() {
      this.editVisible = false;
      this.onChange();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 16px;

  .ant-page-header {
    padding: 0;
  }

  .ant-tabs-nav .ant-tabs-tab {
    margin: 0 8px 0 0;
  }
}

/deep/ .ql-container.ql-snow {
  border: none;
  background: #fafafa;
  padding: 16px
  // font-size: 14px;
}

/deep/ .version-detail {
  .version-action {
    float: right;

    .version-setting {
      margin-left: 16px;
      font-size: 16px;
      line-height: 16px;
    }
  }
}
</style>
